import TitleComponent from "../components/common/TitleComponent";
import pancha from "../assets/images/servceIcon/panchakarma.webp";
import yoga from "../assets/images/servceIcon/yoga.webp";
import medi from "../assets/images/servceIcon/medi.webp";
import doctors from "../assets/images/servceIcon/doctor.webp";
import ward from "../assets/images/servceIcon/ward.webp";
import aftercare from "../assets/images/servceIcon/care.webp";

import service_banner from "../assets/images/bannerImage/service_header.webp";
import BreadcrumbsComponent from "../components/common/BreadcrumbsComponent";

interface Services {
  id: number;
  title: string;
  description: string;
  icon: any;
}

const services: Services[] = [
  {
    id: 1,
    title: "Channeling Services from Over 1,000 Doctors",
    description:
      "Access online and in-person consultations with over 1,000 specialized doctors in Siddha, Unani, and Ayurveda. We focus on providing treatments exclusively for fully curable conditions, ensuring effective and lasting relief.",
    icon: doctors,
  },
  {
    id: 2,
    title: "Convenient Ayurvedic Medications",
    description:
      "Receive standardized Ayurvedic medications conveniently, with traditional herbal decoctions (Kashaya) transformed into easy-to-take tablets under your doctor’s supervision. Available for worldwide distribution through Siddha.lk.",
    icon: medi,
  },
  {
    id: 3,
    title: "Standard Ayurvedic Treatments",
    description:
      "At Ceylon Hospital, we offer a comprehensive range of authentic Ayurvedic treatments, including Panchakarma, therapeutic massages, herbal compress therapy (Pattu), nasal cleansing therapy (Nasna), and steam therapies. Our expert staff uses high-quality medicinal ingredients, strictly following doctor recommendations to ensure safe and effective healing.",
    icon: pancha,
  },
  {
    id: 4,
    title: "Residential Ward Facilities",
    description:
      "Ceylon Hospital provides comprehensive residential ward facilities for patients requiring extended care. Stay in a fully equipped and comfortable environment, with 24-hour medical supervision to ensure precise and effective treatment. Our well-trained staff offers personalized care, catering to your needs throughout your stay. Experience a supportive, healing atmosphere with advanced treatment options and attentive service.",
    icon: ward,
  },
  {
    id: 5,
    title: "Aftercare",
    description:
      "Ceylon Hospital offers 24-hour aftercare through the CH Care service, allowing you to contact your doctor anytime and continuously monitor your condition. This unique service is not provided by other hospitals, highlighting our dedication to your ongoing health and recovery.",
    icon: aftercare,
  },
  {
    id: 6,
    title: "Preventive Care",
    description:
      "In line with Ayurvedic principles, Ceylon Hospital offers preventive care to help you stay disease-free and maintain optimal well-being. Our services include Yoga, wellness treatments, and meditation, methods proven to support long-term health and vitality. Trust us to guide you in maintaining a balanced and healthy lifestyle.",
    icon: yoga,
  },
];

const BreadCrumbsPath = [
  {
    id: 1,
    pathName: "Service",
    pathLink: "/service",
  },
];

const OurServicesContent = () => {
  return (
    <>
      <div className="mt-20 xl:mt-0 hidden md:block">
        <div className="flex mb-2 items-center justify-center">
          <img
            src={service_banner}
            alt="Ceylon Hospital Banner"
            width={1200}
            height={630}
            loading="eager"
            className="w-full  max-w-8xl"
            decoding="async"
            style={{
              height: "auto",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      <BreadcrumbsComponent breadCrumbsPath={BreadCrumbsPath} />
      <div className=" ">
        <div className=" lg:px-10">
          <TitleComponent Title={"We Care Our Patients."} Subtitle={""} />

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-10">
            {services.map((item) => (
              <div
                key={item.id}
                className="group bg-white/50 hover:bg-white rounded-t-md lg:p-9 p-6 hover:shadow-md  lg:mx-0 mx-3
                hover:scale-95 transition-transform duration-500 hover:border-b-green-500 hover:border-b-2  border rounded-md"
              >
                <div className="flex flex-col gap-4 items-center">
                  {/* Icon Animation */}
                  <div
                    className="h-24 w-24 border border-gray-500 p-2 rounded-full 
                         group-hover:bg-green-50 bg-white group-hover:border-none  
                        flex justify-center items-center group-hover:scale-110 
                        transition-transform duration-500"
                  >
                    <img
                      src={item.icon}
                      alt="image"
                      loading="lazy"
                      className="object-cover flex wi"
                    />
                  </div>

                  <div
                    className=" Blinker-SemiBold text-center text-xl text-gray-600 
                     group-hover:text-green-600 group-hover:scale-105
                     transition-all duration-500"
                  >
                    {item.title}
                  </div>

                  <div
                    className="Blinker-Regular text-gray-500 leading-snug text-justify
                     group-hover:text-gray-500 group-hover:scale-105
                     transition-all duration-500"
                  >
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default OurServicesContent;
